import { TrackingEventType, useAnalytics, WalletCustody } from '@capsicum/common';
import { Text, useRouter } from '@capsicum/common-web';
import { useNftLists } from '@capsicum/features/nc-wallet/shared';
import { type MyNft } from '@capsicum/socios-core';
import { NoNftsCard } from '@capsicum/socios-core-web';
import styled from 'styled-components';

import { NCWTabContainer, NftList, NftListSkeleton } from '../../ui';

export const NCWalletNfts = () => {
	const { push } = useRouter();

	const analytics = useAnalytics();

	const { favoriteNfts, isLoading, otherNfts, texts } = useNftLists(WalletCustody.NonCustodial);

	const handleClickNft = (nft: MyNft) => {
		analytics.sendEvent(TrackingEventType.track, 'DigitalCollectibleCardClick', {
			item_id: nft.summary?.collectibleId || ''
		});
		push(`/nfts/${nft.summary?.collectibleId}`);
	};

	return (
		<NCWTabContainer>
			<S.Section>
				{isLoading ? (
					<NftListSkeleton />
				) : (
					<>
						{favoriteNfts?.length === 0 && otherNfts?.length === 0 && (
							<NoNftsCard
								onTriggerClick={() =>
									analytics.sendEvent(
										TrackingEventType.track,
										'DigitalCollectibleNotAvailableInfoTooltipClick'
									)
								}
							/>
						)}
						{favoriteNfts?.length > 0 && (
							<NftList
								nfts={favoriteNfts}
								testID="nc-wallet-nfts-favoriteListCardItem"
								title={texts.favouriteTeamsTitle}
								onClickNft={handleClickNft}
							/>
						)}
						{otherNfts?.length > 0 && (
							<NftList
								nfts={otherNfts}
								testID="nc-wallet-nfts-otherListCardItem"
								title={texts.other}
								onClickNft={handleClickNft}
							/>
						)}
					</>
				)}
			</S.Section>
		</NCWTabContainer>
	);
};

namespace S {
	export const Section = styled.div`
		display: flex;
		flex-flow: column;
		width: 100%;
	`;

	export const Title = styled(Text)`
		text-align: left;
		width: 100%;
	`;
}

export default NCWalletNfts;
